module.exports = __webpack_public_path__ + "img/hard-drive.a27fc279.svg";